import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawMinusIcon from "./RawMinusIcon.svg.jsx";

const MinusIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawMinusIcon} {...props} />;
});

export default MinusIcon;
